module.exports = __webpack_public_path__ + "img/customer_design_4@2x.78e6e52.webp";